import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Logo from "@/components/common/Logo";
import { useSelector } from "react-redux";
import { selectEffectiveUserInfo } from "@/store/redux/slices/auth/auth_slice";
import { getFirstName } from "@/utils/nameUtils";
import Avatar from "@/components/common/Avatar";

const AuthHeader = ({
  logoName = "VeegilLogo",
  logoSize = "small",
  title = "Sign in",
  titlePath = "/signin",
  showTitle = true,
  className = "",
  justifyBetween = false,
  titleClassName = "",
  subtitle = null,
  hideLogo = false,
  showUserGreeting = false,
  rightContent = null,
  avatarSize = 32,
  containerClassName = "",
}) => {
  const userInfo = useSelector(selectEffectiveUserInfo);
  const userFirstName = getFirstName(userInfo?.fullname);

  const userGreeting = (
    <div className="flex items-center">
      <Avatar
        size={avatarSize}
        src={userInfo?.profileImage || undefined}
        className="mr-2"
        alt={userFirstName || "User"}
      />
      <span className="text-bold text-primary">Hello, {userFirstName}</span>
    </div>
  );

  return (
    <div className={`w-full ${containerClassName}`}>
      <div
        className={`flex items-center w-full ${
          justifyBetween ? "justify-between" : ""
        } ${className}`}>
        {!hideLogo && (
          <div className="flex items-center">
            <Logo name={logoName} size={logoSize} />
            {subtitle && (
              <span className="ml-2 text-[24px] text-primary font-roboto-slab font-normal">
                {subtitle}
              </span>
            )}
          </div>
        )}

        {showTitle && (
          <div className={`${titleClassName}`}>
            {titlePath ? (
              <div className="flex items-center">
                <span className="text-small font-medium text-lightGrey hidden md:inline">
                  {title}
                </span>
                <Link to={titlePath}>
                  <span className="text-regular font-bold text-primary ml-1 uppercase">
                    Sign in
                  </span>
                </Link>
              </div>
            ) : (
              <h1 className="text-small font-medium text-primary">{title}</h1>
            )}
          </div>
        )}

        {/* Right content - either custom content or user greeting */}
        {(showUserGreeting || rightContent) && (
          <div className="ml-auto">
            {showUserGreeting ? userGreeting : rightContent}
          </div>
        )}
      </div>
    </div>
  );
};

AuthHeader.propTypes = {
  logoName: PropTypes.string,
  logoSize: PropTypes.string,
  title: PropTypes.string,
  titlePath: PropTypes.string,
  showTitle: PropTypes.bool,
  className: PropTypes.string,
  justifyBetween: PropTypes.bool,
  titleClassName: PropTypes.string,
  subtitle: PropTypes.string,
  hideLogo: PropTypes.bool,
  showUserGreeting: PropTypes.bool,
  rightContent: PropTypes.node,
  avatarSize: PropTypes.number,
  containerClassName: PropTypes.string,
};

export default AuthHeader;
